import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/全称logo横版-02.png'
import _imports_1 from '@/assets/img/logo2.png'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "from" }
const _hoisted_3 = { class: "password" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { ref, onMounted, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { home } from "@/network/index";
import { ElMessage } from 'element-plus'
import { User, Lock } from '@element-plus/icons-vue';
import addDynamicRoutes from '@/utils/addRoutes';
import { useMenuStore } from '@/store/menuStore';
import { clearAuthCache } from '@/utils/authCache';


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const extractPermissionMenus = (responseData: any): any[] => {
    if (!responseData) return [];
    if (Array.isArray(responseData)) return responseData;
    if (Array.isArray(responseData.children)) return responseData.children;
    return [];
};

const loginLoading = ref(false); 
const input = ref("");
const password = ref("");
const router = useRouter()

// 修改密码相关
const showChangePasswordDialog = ref(false);
const changePasswordLoading = ref(false);
const changePasswordForm = ref({
    name: '',
    oldpass: '',
    pass: ''
});

// 修改密码处理函数
const handleChangePassword = async () => {
    if (!changePasswordForm.value.name || !changePasswordForm.value.oldpass || !changePasswordForm.value.pass) {
        ElMessage.warning('请填写完整信息');
        return;
    }
    
    changePasswordLoading.value = true;
    try {
        const res = await home.ChangePassword({
            name: changePasswordForm.value.name,
            pass: changePasswordForm.value.pass,
            oldpass: changePasswordForm.value.oldpass
        }) as { status?: number; success?: boolean; msg?: string; data?: { msg?: string } };
        
        const isSuccess = res.success === true || res.status === 200 || res.msg?.includes('成功');
        if (isSuccess) {
            ElMessage.success(res.msg || '密码修改成功');
            showChangePasswordDialog.value = false;
            // 清空表单
            changePasswordForm.value = { name: '', oldpass: '', pass: '' };
        } else {
            ElMessage.error(res.msg || res.data?.msg || '密码修改失败');
        }
    } catch (error) {
        console.error('修改密码失败:', error);
        ElMessage.error('修改密码请求失败');
    } finally {
        changePasswordLoading.value = false;
    }
};
// const data:any = reactive({});


const login = async () => {
 // 如果正在登录中，则不处理重复点击
 if (loginLoading.value) return;
 loginLoading.value = true;
    
    // 设置loading状态
    loginLoading.value = true;
    
try {
    
    //正常登录流程
    const res = await home.PostLogin({
        name: input.value,
        pass: password.value
    }) as { status: number; response: { token: string }; data?: { msg: string } };
    
    // 判断HTTP状态码
    if (res.status !== 200) {
        ElMessage({ message: '网络请求失败，请稍后再试!', type: 'error' })
        return;
    }
    
    // 判断业务逻辑错误（如认证失败）
    if (res.data?.msg && res.data.msg.includes('认证')) {
        ElMessage({ message: '用户名或密码错误!', type: 'error' })
        return;
    }
    
    console.log("登录", JSON.parse(JSON.stringify(res)));
    
    // 登录成功
    const menus = res.response.token;
    const menuStore = useMenuStore();
    clearAuthCache();
    menuStore.clearMenus();
    sessionStorage.setItem('wuyetoken', menus)//浏览器缓存存储
    localStorage.setItem('wuyetoken', menus)//持久化存储，支持新标签页打开
    //存储信息
    const tokenData = await home.GetInfoByToken({ token: menus }) as { response: { uID: string } };
    console.log(tokenData);
    // 获取用户权限菜单
    let menusData: any[] = [];
    try {
        const permissionRes = await home.GetUserPermission(
            { uid: tokenData.response.uID },
            { suppressBusinessErrorMessage: true }
        );
        menusData = extractPermissionMenus(permissionRes.response);
    } catch (permissionError) {
        console.error("获取权限菜单失败", permissionError);
        menusData = [];
    }

    localStorage.setItem('wuyemenusJSON', JSON.stringify(menusData));
    const buttonPermissions: string[] = [];
    
    const extractButtonPermissions = (menus: any[]) => {
        menus.forEach(menu => {
            if (menu.IsButton) {
                const permissionName = menu.Func || menu.name || menu.meta?.title;
                if (permissionName) buttonPermissions.push(permissionName);
            }
            
            if (menu.children && menu.children.length > 0) {
                extractButtonPermissions(menu.children);
            }
        });
    };
    
    extractButtonPermissions(menusData);
    localStorage.setItem('buttonPermissions', JSON.stringify(buttonPermissions));
    localStorage.setItem('menuPermissionSyncedAt', String(Date.now()));
    menuStore.setMenus(menusData);
    addDynamicRoutes(router, menusData);

    if (menusData.length === 0) {
        ElMessage({
            message: '当前人员无菜单权限，为您登录首页',
            type: 'success',
            customClass: 'login-empty-menu-message'
        });
    } else {
        ElMessage({ message: '登录成功!', type: 'success' })
    }

    router.push("/home");
} catch (error: unknown) {
    console.error("登录请求失败:", error);
    // ElMessage({ message: '登录失败，请检查用户名和密码!', type: 'error' });
}finally {
    loginLoading.value = false;
}
};

//添加监听
onBeforeMount(() => {
console.log("组件首次挂载之前");
});

onMounted(() => {
console.log("组件首次挂载完成");
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "logo-container" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Logo",
        class: "logo"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"system-title\" data-v-1d2f457e><img src=\"" + _imports_1 + "\" alt=\"智检云枢\" class=\"system-logo\" data-v-1d2f457e><div class=\"system-brand\" data-v-1d2f457e>智检云枢</div><div class=\"brand-line\" data-v-1d2f457e></div><h1 data-v-1d2f457e>建研国检智能检测系统</h1><div class=\"title-subtitle\" data-v-1d2f457e>CABR TESTING CENTER Intelligent Detection System</div></div>", 1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(login, ["prevent"]),
        autocomplete: "on"
      }, [
        _createVNode(_component_el_input, {
          modelValue: input.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
          size: "large",
          placeholder: "请输入您的账号",
          "prefix-icon": _unref(User),
          name: "username",
          autocomplete: "username"
        }, null, 8, ["modelValue", "prefix-icon"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            onKeyup: _withKeys(login, ["enter"]),
            size: "large",
            type: "password",
            placeholder: "请输入您的密码",
            "show-password": "",
            "prefix-icon": _unref(Lock),
            name: "password",
            autocomplete: "current-password"
          }, null, 8, ["modelValue", "prefix-icon"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["login-btn", { loading: loginLoading.value }]),
          onClick: login
        }, [
          (!loginLoading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "登录"))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "登录中..."))
        ], 2),
        _createElementVNode("div", {
          class: "change-password-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showChangePasswordDialog.value = true))
        }, " 修改密码 ")
      ], 32)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showChangePasswordDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showChangePasswordDialog).value = $event)),
      title: "修改密码",
      width: "400px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (showChangePasswordDialog.value = false))
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleChangePassword,
          loading: changePasswordLoading.value
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" 确定 ")
          ])),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: changePasswordForm.value,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: changePasswordForm.value.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((changePasswordForm.value.name) = $event)),
                  placeholder: "请输入用户名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "旧密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: changePasswordForm.value.oldpass,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((changePasswordForm.value.oldpass) = $event)),
                  type: "password",
                  placeholder: "请输入旧密码",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "新密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: changePasswordForm.value.pass,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((changePasswordForm.value.pass) = $event)),
                  type: "password",
                  placeholder: "请输入新密码",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})